import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { Season } from '../../shared/season.model';
import { SeasonService } from '../../shared/season.service';

@Component({
  selector: 'app-season-translation-modal',
  templateUrl: './season-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class SeasonTranslationModalComponent {
  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private seasonService: SeasonService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<SeasonTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getSeason();
  }

  season: Season = null;
  seasonCopy = null;

  modalTitle = this.data.title;
  seasonId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  // Referenced from app-item-detail-form-actions
  onSavedSeasonTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name'];

    if (!fields.some((field) => formData[field] !== this.seasonCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.seasonService.saveSeason(this.season.id, formData, this.language.lang).subscribe({
      next: (response) => {
        this.alertService.open('TRANSLATION_SAVED');

        this.sendingForm = false;

        this.ref.close(response);
      },
      error: (response) => {
        this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

        this.sendingForm = false;
      },
    });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getSeason() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.seasonService.getSeason(this.seasonId, params).subscribe((season) => {
      this.season = season;
      this.seasonCopy = { ...this.season };

      this.setSeasonTranslationForm();

      this.form.patchValue(this.season);
    });
  }

  private setSeasonTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), // use it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      season: '',
    });
  }
}
